// Explicitly provisional print-only wording for Trust CONCEPT demonstrations.
// These are machine-assisted language drafts, not a clinical, professional
// translation, or Trust publication release. Clinical Journey sentences use
// the existing app packs rather than inventing a second translation set.
export const CONCEPT_PRINT_LABEL_DRAFTS = Object.freeze({
  bn: {
    whatMayHappen: 'কী হতে পারে',
    whyItMayHappen: 'এটি কেন হতে পারে',
    whatTeamIsDoing: 'আপনার স্বাস্থ্যসেবা দল কী করছে',
    variationNote: 'এটি ভিন্ন হতে পারে',
    nextSteps: 'এরপর কী হতে পারে',
    professionalClothes: 'সাধারণত নির্দিষ্ট ইউনিফর্মের বদলে পেশাগত পোশাক পরেন।',
    wearsColourGarment: 'সাধারণত {colour} রঙের {garment} পরেন।',
    wearsGarment: 'সাধারণত {garment} পরেন।',
    genericGarment: 'চিকিৎসাকর্মীর পোশাক',
    preparationChecklist: 'আমার প্রস্তুতির যাচাইতালিকা',
    understandingReminder: 'হাসপাতালের প্রস্তুতির নির্দেশনা মেনে চলুন। কোনো বিষয় স্পষ্ট না হলে স্বাস্থ্যসেবা দলকে জিজ্ঞাসা করুন।',
    whatYouMightHear: 'আপনি যেসব কথা শুনতে পারেন',
    whatItMeans: 'এর অর্থ:',
    questionsToConsider: 'আপনি যে প্রশ্নগুলো করতে চাইতে পারেন',
    peopleYouMayMeet: 'আপনি কাদের সঙ্গে দেখা করতে পারেন',
    clothes: 'পোশাক:',
    officialHospitalInformation: 'হাসপাতালের দরকারি তথ্য',
    localHospital: 'স্থানীয় হাসপাতাল',
    forLocalReview: 'স্থানীয় হাসপাতালের পর্যালোচনার জন্য',
    evaluationDraft: 'পর্যালোচনার খসড়া',
    prepared: 'প্রস্তুত করা হয়েছে',
    coverReminder: 'এই নির্দেশিকা আপনাকে তথ্য জানতে ও প্রস্তুতি নিতে সাহায্য করে। নিজের হাসপাতালের দলের নির্দেশনা সব সময় মেনে চলুন।',
    stage: 'ধাপ',
    of: 'এর',
    yourCareTeam: 'আপনার স্বাস্থ্যসেবা দল',
    questionsAndNotes: 'প্রশ্ন ও নোট',
    questionsToAskMyTeam: 'আমার স্বাস্থ্যসেবা দলকে করার প্রশ্ন',
    writingPrompt: 'হাসপাতালের দলকে যা জিজ্ঞাসা করতে চান, তা এখানে লিখে রাখুন।',
    spaceForQuestions: 'প্রশ্ন লেখার জায়গা',
    notesToRemember: 'মনে রাখার বিষয়',
    notesPrompt: 'তারিখ, নির্দেশনা বা অন্য নোট লিখতে এই জায়গা ব্যবহার করুন।',
    spaceForNotes: 'নোট লেখার জায়গা',
    importantInformation: 'গুরুত্বপূর্ণ তথ্য',
    pleaseRemember: 'মনে রাখবেন',
    askForExplanation: 'কিছু অস্পষ্ট হলে হাসপাতালের দলের কাছে ব্যাখ্যা চাইুন।',
    footerAdvice: 'নিজের হাসপাতালের দলের সঙ্গে নির্দেশনাগুলো যাচাই করুন।',
  },
  pa: {
    whatMayHappen: 'ਕੀ ਹੋ ਸਕਦਾ ਹੈ',
    whyItMayHappen: 'ਇਹ ਕਿਉਂ ਹੋ ਸਕਦਾ ਹੈ',
    whatTeamIsDoing: 'ਤੁਹਾਡੀ ਦੇਖਭਾਲ ਟੀਮ ਕੀ ਕਰ ਰਹੀ ਹੈ',
    variationNote: 'ਇਹ ਵੱਖਰਾ ਹੋ ਸਕਦਾ ਹੈ',
    nextSteps: 'ਅੱਗੇ ਕੀ ਹੋ ਸਕਦਾ ਹੈ',
    professionalClothes: 'ਆਮ ਤੌਰ ਉੱਤੇ ਮਿਆਰੀ ਵਰਦੀ ਦੀ ਬਜਾਏ ਪੇਸ਼ੇਵਰ ਕੱਪੜੇ ਪਹਿਨਦੇ ਹਨ।',
    wearsColourGarment: 'ਆਮ ਤੌਰ ਉੱਤੇ {colour} ਰੰਗ ਦੇ {garment} ਪਹਿਨਦੇ ਹਨ।',
    wearsGarment: 'ਆਮ ਤੌਰ ਉੱਤੇ {garment} ਪਹਿਨਦੇ ਹਨ।',
    genericGarment: 'ਡਾਕਟਰੀ ਪਹਿਰਾਵਾ',
    preparationChecklist: 'ਮੇਰੀ ਤਿਆਰੀ ਦੀ ਜਾਂਚ ਸੂਚੀ',
    understandingReminder: 'ਹਸਪਤਾਲ ਦੀਆਂ ਤਿਆਰੀ ਸੰਬੰਧੀ ਹਦਾਇਤਾਂ ਮੰਨੋ। ਕੋਈ ਗੱਲ ਸਪੱਸ਼ਟ ਨਾ ਹੋਵੇ ਤਾਂ ਆਪਣੀ ਦੇਖਭਾਲ ਟੀਮ ਨੂੰ ਪੁੱਛੋ।',
    whatYouMightHear: 'ਉਹ ਗੱਲਾਂ ਜੋ ਤੁਸੀਂ ਸੁਣ ਸਕਦੇ ਹੋ',
    whatItMeans: 'ਇਸ ਦਾ ਅਰਥ:',
    questionsToConsider: 'ਉਹ ਸਵਾਲ ਜੋ ਤੁਸੀਂ ਪੁੱਛਣਾ ਚਾਹ ਸਕਦੇ ਹੋ',
    peopleYouMayMeet: 'ਤੁਸੀਂ ਕਿਨ੍ਹਾਂ ਨੂੰ ਮਿਲ ਸਕਦੇ ਹੋ',
    clothes: 'ਪਹਿਰਾਵਾ:',
    officialHospitalInformation: 'ਹਸਪਤਾਲ ਤੋਂ ਲਾਭਦਾਇਕ ਜਾਣਕਾਰੀ',
    localHospital: 'ਸਥਾਨਕ ਹਸਪਤਾਲ',
    forLocalReview: 'ਸਥਾਨਕ ਹਸਪਤਾਲ ਦੀ ਸਮੀਖਿਆ ਲਈ',
    evaluationDraft: 'ਸਮੀਖਿਆ ਲਈ ਮਸੌਦਾ',
    prepared: 'ਤਿਆਰ ਕੀਤਾ',
    coverReminder: 'ਇਹ ਗਾਈਡ ਜਾਣਕਾਰੀ ਅਤੇ ਤਿਆਰੀ ਲਈ ਹੈ। ਆਪਣੀ ਹਸਪਤਾਲ ਟੀਮ ਦੀਆਂ ਹਦਾਇਤਾਂ ਦੀ ਹਮੇਸ਼ਾਂ ਪਾਲਣਾ ਕਰੋ।',
    stage: 'ਪੜਾਅ',
    of: 'ਵਿੱਚੋਂ',
    yourCareTeam: 'ਤੁਹਾਡੀ ਦੇਖਭਾਲ ਟੀਮ',
    questionsAndNotes: 'ਸਵਾਲ ਅਤੇ ਨੋਟ',
    questionsToAskMyTeam: 'ਮੇਰੀ ਟੀਮ ਨੂੰ ਪੁੱਛਣ ਵਾਲੇ ਸਵਾਲ',
    writingPrompt: 'ਉਹ ਸਵਾਲ ਇੱਥੇ ਲਿਖੋ ਜੋ ਤੁਸੀਂ ਆਪਣੀ ਹਸਪਤਾਲ ਟੀਮ ਨੂੰ ਪੁੱਛਣਾ ਚਾਹੁੰਦੇ ਹੋ।',
    spaceForQuestions: 'ਸਵਾਲ ਲਿਖਣ ਲਈ ਥਾਂ',
    notesToRemember: 'ਯਾਦ ਰੱਖਣ ਵਾਲੀਆਂ ਗੱਲਾਂ',
    notesPrompt: 'ਤਾਰੀਖਾਂ, ਹਦਾਇਤਾਂ ਜਾਂ ਹੋਰ ਨੋਟ ਇੱਥੇ ਲਿਖੋ।',
    spaceForNotes: 'ਨੋਟ ਲਿਖਣ ਲਈ ਥਾਂ',
    importantInformation: 'ਮਹੱਤਵਪੂਰਨ ਜਾਣਕਾਰੀ',
    pleaseRemember: 'ਕਿਰਪਾ ਕਰਕੇ ਯਾਦ ਰੱਖੋ',
    askForExplanation: 'ਜੇ ਕੋਈ ਗੱਲ ਸਪੱਸ਼ਟ ਨਹੀਂ ਹੈ ਤਾਂ ਆਪਣੀ ਹਸਪਤਾਲ ਟੀਮ ਤੋਂ ਵਿਆਖਿਆ ਮੰਗੋ।',
    footerAdvice: 'ਆਪਣੀ ਹਸਪਤਾਲ ਟੀਮ ਨਾਲ ਹਦਾਇਤਾਂ ਦੀ ਪੁਸ਼ਟੀ ਕਰੋ।',
  },
  fr: {
    whatMayHappen: 'Ce qui peut se passer', whyItMayHappen: 'Pourquoi cela peut arriver',
    whatTeamIsDoing: 'Ce que fait votre équipe soignante', variationNote: 'Cela peut varier',
    nextSteps: 'Ce qui peut se passer ensuite', genericGarment: 'tenue de soins',
    whatItMeans: 'Ce que cela signifie :', clothes: 'Tenue :',
    forLocalReview: 'Pour examen par votre établissement',
    evaluationDraft: 'Document de démonstration', prepared: 'Préparé le',
    stage: 'Étape', of: 'sur', yourCareTeam: 'Votre équipe soignante',
    questionsAndNotes: 'Questions et notes', questionsToAskMyTeam: 'Questions à poser à mon équipe',
    writingPrompt: 'Notez ici ce que vous souhaitez demander à votre équipe hospitalière.',
    spaceForQuestions: 'Espace pour écrire vos questions', notesToRemember: 'Notes à retenir',
    notesPrompt: 'Utilisez cet espace pour les dates, les consignes ou d’autres notes.',
    spaceForNotes: 'Espace pour vos notes',
    importantInformation: 'Informations importantes', pleaseRemember: 'À retenir',
    askForExplanation: 'Si quelque chose n’est pas clair, demandez à votre équipe hospitalière de vous l’expliquer.',
    footerAdvice: 'Vérifiez les consignes auprès de votre équipe hospitalière.',
    coverReminder: 'Ce guide vous aide à vous informer et à vous préparer. Suivez toujours les conseils de votre propre équipe hospitalière.',
  },
  es: {
    whatMayHappen: 'Qué puede ocurrir', whyItMayHappen: 'Por qué puede ocurrir',
    whatTeamIsDoing: 'Qué hace su equipo asistencial', variationNote: 'Esto puede variar',
    nextSteps: 'Qué puede ocurrir después', genericGarment: 'ropa clínica',
    whatItMeans: 'Qué significa:', clothes: 'Ropa:',
    forLocalReview: 'Para revisión del hospital',
    evaluationDraft: 'Borrador de demostración', prepared: 'Preparado el',
    stage: 'Etapa', of: 'de', yourCareTeam: 'Su equipo asistencial',
    questionsAndNotes: 'Preguntas y notas', questionsToAskMyTeam: 'Preguntas para mi equipo',
    writingPrompt: 'Anote cualquier pregunta que desee hacer a su equipo del hospital.',
    spaceForQuestions: 'Espacio para sus preguntas', notesToRemember: 'Notas que recordar',
    notesPrompt: 'Utilice este espacio para fechas, instrucciones u otras notas.',
    spaceForNotes: 'Espacio para notas', importantInformation: 'Información importante',
    pleaseRemember: 'Recuerde',
    askForExplanation: 'Si algo no está claro, pida una explicación a su equipo del hospital.',
    footerAdvice: 'Confirme las indicaciones con el equipo de su hospital.',
    coverReminder: 'Esta guía sirve para informarse y prepararse. Siga siempre las indicaciones de su propio equipo del hospital.',
  },
  ar: {
    whatMayHappen: 'ما قد يحدث', whyItMayHappen: 'لماذا قد يحدث ذلك',
    whatTeamIsDoing: 'ما الذي يفعله فريق رعايتك', variationNote: 'قد يختلف ذلك',
    nextSteps: 'ما الذي قد يحدث بعد ذلك', genericGarment: 'ملابس طبية',
    whatItMeans: 'ماذا يعني ذلك:', clothes: 'الملابس:',
    forLocalReview: 'لمراجعة المستشفى', evaluationDraft: 'مسودة للعرض التوضيحي',
    prepared: 'أُعدّ في', stage: 'المرحلة', of: 'من',
    yourCareTeam: 'فريق رعايتك',
    questionsAndNotes: 'الأسئلة والملاحظات', questionsToAskMyTeam: 'أسئلة أود طرحها على فريقي',
    writingPrompt: 'دوّن أي أسئلة ترغب في طرحها على فريق المستشفى.',
    spaceForQuestions: 'مساحة لكتابة الأسئلة', notesToRemember: 'ملاحظات للتذكّر',
    notesPrompt: 'استخدم هذه المساحة لتسجيل التواريخ أو التعليمات أو الملاحظات الأخرى.',
    spaceForNotes: 'مساحة للملاحظات',
    importantInformation: 'معلومات مهمة', pleaseRemember: 'يرجى التذكّر',
    askForExplanation: 'إذا كان أي شيء غير واضح، فاطلب من فريق المستشفى توضيحه.',
    footerAdvice: 'تأكد من التعليمات مع فريق المستشفى الذي يعالجك.',
    coverReminder: 'يساعدك هذا الدليل على الفهم والاستعداد. اتبع دائماً تعليمات فريق المستشفى الذي يعالجك.',
  },
  pl: {
    whatMayHappen: 'Co może się wydarzyć', whyItMayHappen: 'Dlaczego może się to wydarzyć',
    whatTeamIsDoing: 'Co robi zespół opieki', variationNote: 'Może to wyglądać inaczej',
    nextSteps: 'Co może się wydarzyć dalej', genericGarment: 'odzież medyczna',
    whatItMeans: 'Co to oznacza:', clothes: 'Ubranie:',
    forLocalReview: 'Do weryfikacji przez szpital', evaluationDraft: 'Wersja demonstracyjna',
    prepared: 'Przygotowano', stage: 'Etap', of: 'z',
    yourCareTeam: 'Twój zespół opieki',
    questionsAndNotes: 'Pytania i notatki', questionsToAskMyTeam: 'Pytania do mojego zespołu',
    writingPrompt: 'Zapisz pytania, które chcesz zadać personelowi szpitala.',
    spaceForQuestions: 'Miejsce na pytania', notesToRemember: 'Ważne notatki',
    notesPrompt: 'Wpisz tutaj daty, zalecenia lub inne notatki.',
    spaceForNotes: 'Miejsce na notatki',
    importantInformation: 'Ważne informacje', pleaseRemember: 'Pamiętaj',
    askForExplanation: 'Jeśli coś jest niejasne, poproś personel szpitala o wyjaśnienie.',
    footerAdvice: 'Potwierdź zalecenia z personelem swojego szpitala.',
    coverReminder: 'Ten przewodnik służy do informacji i przygotowania. Zawsze postępuj zgodnie z zaleceniami swojego zespołu szpitalnego.',
  },
  ur: {
    whatMayHappen: 'کیا ہو سکتا ہے', whyItMayHappen: 'ایسا کیوں ہو سکتا ہے',
    whatTeamIsDoing: 'آپ کی نگہداشت کی ٹیم کیا کر رہی ہے', variationNote: 'یہ مختلف ہو سکتا ہے',
    nextSteps: 'آگے کیا ہو سکتا ہے', genericGarment: 'طبی لباس',
    whatItMeans: 'اس کا مطلب:', clothes: 'لباس:',
    forLocalReview: 'ہسپتال کے جائزے کے لیے', evaluationDraft: 'نمائشی مسودہ',
    prepared: 'تیار کردہ', stage: 'مرحلہ', of: 'میں سے',
    yourCareTeam: 'آپ کی نگہداشت کی ٹیم',
    questionsAndNotes: 'سوالات اور نوٹس', questionsToAskMyTeam: 'اپنی ٹیم سے پوچھنے کے سوالات',
    writingPrompt: 'وہ سوالات لکھیں جو آپ ہسپتال کی ٹیم سے پوچھنا چاہتے ہیں۔',
    spaceForQuestions: 'سوالات لکھنے کی جگہ', notesToRemember: 'یاد رکھنے کے لیے نوٹس',
    notesPrompt: 'یہ جگہ تاریخوں، ہدایات یا دوسرے نوٹس کے لیے استعمال کریں۔',
    spaceForNotes: 'نوٹس کے لیے جگہ',
    importantInformation: 'اہم معلومات', pleaseRemember: 'براہ کرم یاد رکھیں',
    askForExplanation: 'اگر کوئی بات واضح نہ ہو تو ہسپتال کی ٹیم سے وضاحت مانگیں۔',
    footerAdvice: 'اپنے ہسپتال کی ٹیم سے ہدایات کی تصدیق کریں۔',
    coverReminder: 'یہ رہنما معلومات اور تیاری کے لیے ہے۔ اپنی ہسپتال کی ٹیم کی ہدایات پر عمل کریں۔',
  },
});
